import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { statusObj } from 'src/app/dummy/status';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { DataService } from 'src/app/services/data.service';
import { pageKey, toNumber, MappingService, toDateKey } from 'src/app/services/mapping.service';
import { List } from 'src/app/stores/administrator/list.store';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { IClassSchedule, IClassReading } from 'src/app/interfaces/enrollment';
import { ConvertService } from 'src/app/services/convert.service';
import { Observable } from 'rxjs';
import { ClassroomStore } from 'src/app/stores/enrollment/classroom.store';

@Component({
  selector: 'app-add-enroll-reading',
  templateUrl: './add-enroll-reading.component.html',
  styleUrls: ['./add-enroll-reading.component.scss']
})
export class AddEnrollReadingComponent implements OnInit {
  @ViewChild('focusInput', { static: false }) inputEl: ElementRef;

  form: FormGroup;
  title: AbstractControl;
  reading_book: AbstractControl;
  expire_date: AbstractControl;
  note: AbstractControl;

  filteredReadingBookStates: Observable<any[]>;

  process: boolean = true;
  constructor(public dialogRef: MatDialogRef<AddEnrollReadingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public auth: AuthStore,
    public ds: DataService,
    private snackBar: MatSnackBar,
    public list: List,
    public store: ClassroomStore,
  ) { }

  buildForm(): void {
    this.form = this.fb.group({
      reading_book: [null, Validators.compose([Validators.required, MappingService.validSelected.bind(this)])],
      title: [null, Validators.required],
      expire_date: [new Date(), Validators.required],
      note: [null],
    });
    this.reading_book = this.form.controls['reading_book'];
    this.title = this.form.controls['title'];
    this.expire_date = this.form.controls["expire_date"];
    this.note = this.form.controls["note"];
  }

  async ngOnInit() {
    this.buildForm();

    const { classKey } = this.store.selectedClass;
    const readingBookData = await this.list.fetchList(this.ds.adprogramCollectRef().doc(classKey).collection("reading_books"));

    this.filteredReadingBookStates = MappingService.autoComplete(this.reading_book, readingBookData, "name.name");

    this.process = false;
  }

  compareObjects(o1: any, o2: any): boolean {
    return o1 && o2 ? o1.key === o2.key : o1 === o2;
  }

  displayItemName(item: any): string {
    return item ? item.name.name : item;
  }

  create(f: any, isNew) {
    if (this.form.valid) {
      const { title, note, reading_book, expire_date } = f;
      const { classKey } = this.store.selectedClass;

      const item: IClassReading = {
        key: this.ds.createId(),
        page_key: pageKey(),
        created_at: new Date(),
        created_byRef: this.ds.userRef().doc(`${this.auth.user.uid}`).ref,
        created_by: this.auth.user.uid,
        updated_at: new Date(),
        updated_byRef: this.ds.userRef().doc(`${this.auth.user.uid}`).ref,
        updated_by: this.auth.user.uid,
        isDelete: false,
        status: statusObj.active,
        keyword: ConvertService.toCapitalize(`${title.trim()}`),

        title,
        note,
        expire_date,
        expire_date_key: toDateKey(expire_date),
        readingBookName: reading_book.name,
        readingBookKey: reading_book.key,
        readingBookRef: this.ds.adprogramCollectRef().doc(classKey).collection("reading_books").doc(`${reading_book.key}`).ref,

        classRoomKey: this.store.selectedClass.key,
        classRoomRef: this.ds.classRoomRef().doc(`${this.store.selectedClass.key}`).ref,
      };

      this.store.addReadingBook(item, (success, error) => {
        if (success) {
          if (!isNew) {
            this.dialogRef.close();
          }
          this.snackBar.open('Reading Book has been created successfully.', 'done', { duration: 2000 });
          this.form.reset();
        } else {
          this.snackBar.open(error, 'Error');
        }
      });

    }
  }

}
